import type { Tagged } from "@-/com.npmjs.type-fest";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";
import { useIsOnboardingIntro } from "@-/dev.improve.haniverse.lib.onboarding";

export type OnboardingIntroOverlayGate = Tagged<object, "OnboardingIntroOverlayGate">;

/** The globe and its questions cover the app until their reaction (`intro`) has played. */
export function useOnboardingIntroOverlayGate(): OnboardingIntroOverlayGate | null {
  return useIsOnboardingIntro() ? createGate<OnboardingIntroOverlayGate>({}) : null;
}
